import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LayoutComponent } from 'libs/portal/src/layout/layout.component';
import { AuthGuardService } from 'libs/portal/src/services/auth-guard/auth-guard.service';

import { KeepalivePageComponent } from './pages/keepalive/keepalive.page';

const routes: Routes = [
  {
    path: 'Dashboard',
    component: LayoutComponent,
    data: { breadcrumb: 'Dashboard' },
    children: [
      {
        path: '',
        canActivate: [AuthGuardService],
        component: KeepalivePageComponent,
        pathMatch: 'full',
      },
    ],
  },
  {
    path: 'Devices',
    canActivate: [AuthGuardService],
    // component: LayoutComponent,
    data: { breadcrumb: 'Devices' },
    loadChildren: () => import('./pages/devices/devices.module').then((m) => m.DevicesModule),
  },
  // {
  //   path: "Alerts",
  //   canActivate: [AuthGuardService],
  //   component: LayoutComponent,
  //   data: { breadcrumb: 'Alerts'},
  //   loadChildren: () =>
  //     import("./pages/alerts/alerts.module").then((m) => m.AlertsModule),
  // },
  // {
  //   path: "Reports",
  //   canActivate: [AuthGuardService],
  //   component: LayoutComponent,
  //   data: { breadcrumb: 'Reports'},
  //   loadChildren: () =>
  //     import("./pages/reports/reports.module").then((m) => m.ReportsModule),
  // },
  // {
  //   path: "Report/:id",
  //   canActivate: [AuthGuardService],
  //   component: LayoutComponent,
  //   loadChildren: () =>
  //     import("./pages/report-details/report-details.module").then(
  //       (m) => m.ReportDetailsModule
  //     ),
  // },
  {
    path: 'Map',
    canActivate: [AuthGuardService],
    component: LayoutComponent,
    data: { breadcrumb: 'Map' },
    loadChildren: () => import('./pages/map/map.module').then((m) => m.MapModule),
  },
  {
    path: 'RingfenceLogs',
    canActivate: [AuthGuardService],
    component: LayoutComponent,
    loadChildren: () => import('./pages/device-logs/device-logs.module').then((m) => m.DeviceLogsModule),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [AuthGuardService],
})
export class KeepalivePageRoutingModule {}
